<template>
  <div>
    <div v-if="params.isFilterRenderer">
      {{ setFilterValue }}
      <span v-if="params.value !== '(Select All)'">
        {{ '(' }}
        <span class="kachel-badge kachel-badge-sm" :class="colorClass" :style="customStyles">
          {{ value }}
        </span>
        {{ ')' }}
      </span>
      <div v-else>(Select All)</div>
    </div>
    <div v-else>
      <span
        v-if="params.value !== '(Select All)'"
        class="kachel-badge"
        :class="colorClass"
        :style="customStyles"
      >
        {{ value }}
      </span>
      <div v-else>(Select All)</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      variant: null,
      value: null,
      setFilterValue: null,
      customStyles: null,
    };
  },
  computed: {
    colorClass() {
      return (
        { danger: 'red', warning: 'yellow', success: 'green', secondary: 'gray' }[this.variant] ?? 'gray'
      );
    },
  },
  mounted() {
    if (this.params && this.params.value) {
      if (this.params.value === 'NichtVerfuegbar') {
        this.variant = 'danger';
        this.value = 'N';
        this.setFilterValue = 'Nicht verfügbar';
      } else if (this.params.value === 'AufAnfrage') {
        this.variant = 'secondary';
        this.value = 'RQ';
        this.setFilterValue = 'Auf Anfrage';
      } else if (this.params.value === 'Verfuegbar') {
        this.variant = 'success';
        this.value = 'J';
        this.setFilterValue = 'Verfügbar';
      } else if (this.params.value === 'Verfuegbar>200') {
        this.value = 'J';
        this.variant = 'danger';
        this.setFilterValue = 'Verfügbar >200€';
      } else if (this.params.value === 'Verfuegbar<200') {
        this.variant = 'success';
        this.value = 'J';
        this.setFilterValue = 'Verfügbar <200€';
      }

      if (this.params.isFilterRenderer && this.params.getCustomStyles) {
        const styles = this.params.getCustomStyles(this.params.value);
        if (styles) {
          this.customStyles = styles;
        }
      }
    }
  },
};
</script>
